import { BROWSER_EVENTS } from "@cms/utils/constants";
import Popover from "@mui/material/Popover";
import React, { useEffect, useState } from "react";

interface SystemPopoverProps {
    trigger: {
        component: React.ReactNode
        disabled?: boolean
    };
    content: {
        component: React.ReactElement<any>;
        shouldCloseOnItemClick?: boolean;
    }
}

export const SystemPopover: React.FC<SystemPopoverProps> = (props) => {
    const { trigger, content } = props;

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleClickMainLabel = (event: React.MouseEvent<HTMLDivElement>) => {
        if (trigger.disabled) return;
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    }

    useEffect(() => {
        const handler = () => {
            handleClose();
        }

        window.addEventListener(BROWSER_EVENTS.CLOSE_MODAL, handler);

        return () => window.removeEventListener(BROWSER_EVENTS.CLOSE_MODAL, handler);
    }, []);

    return (
        <React.Fragment>
            <div
                onClickCapture={handleClickMainLabel}
            >
                {trigger.component}
            </div>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {content.component}
            </Popover>
        </React.Fragment>
    )
}
